import { useCallback } from "react";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { OptionStock_StockManagement_Query } from "./query";

type Props = {
	hotelID: string;
	startDt: string;
	endDt: string;
};

/**
 * 年月に紐づくオプション在庫を取得する
 * @returns
 */
export const useFetchOptionStock = ({ hotelID, startDt, endDt }: Props) => {
	// プラン在庫取得ロジック
	const { data, refetch } = useCustomSuspenseQuery(OptionStock_StockManagement_Query, {
		variables: { hotelID, startDt, endDt },
	});

	const onFetchOptionStock = useCallback(
		async ({ input: { startDt, endDt } }: { input: { startDt: string; endDt: string } }) => {
			return await refetch({ hotelID, startDt, endDt });
		},
		[hotelID, refetch],
	);

	return {
		data,
		onFetchOptionStock,
	};
};
